
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.65 11.478l-5.867-1.304A1 1 0 0112 9.198V3.993a1.993 1.993 0 10-3.986 0v8.994a.307.307 0 01-.563.171l-.456-.68c-1.075-1.608-3.563-1.072-3.88.835-.075.447-.006.905.197 1.31l2.872 5.722A3 3 0 008.865 22H18a3 3 0 003-3v-4.594a3 3 0 00-2.35-2.928z"}})])
          )
        }
      }
    